import React, { useEffect, useRef, useState, useContext } from 'react';
import PageNav from '../components/PageNav';
import classNames from 'classnames';
import { HomeworkSvg } from '../svg/svgs';
import useOnClick from '../components/common/ClosePopUp';
import axios from 'axios';
import loadingSpin from '../images/loadingSpin.gif';
import { animated, useSpring } from 'react-spring';
import { Link, useLocation } from 'react-router-dom';
import BareboneModal from "../components/common/BareboneModal";
import Card from '../components/common/Card';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmptyContent from '../components/common/EmptyContent';
import Visibility from '../components/common/Visibility';
import ContentCopy from '../components/common/ContentCopy';
import ErrorOutline from '../components/common/ErrorOutline';
import PaymentCard from '../components/PaymentsCard';
import { DataContext } from '../context/DataContext';
import BillsCard from '../components/BillsCard';
import NewPayments from '../pages/NewPayments';
import Payments from '../pages/Payments';
import BillHistory from '../pages/BillHistory';
import Button from "../components/common/Button";
import FormSuccess from "../components/common/FormSuccess";
import FormInput from "../components/FormInput";
import Label from "../components/common/Label";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormError from "../components/common/FormError";

const Billings = () => {
  const studentInfo = JSON.parse(localStorage.getItem("studentInfo"))[0];
  const studentAdmissionNum = studentInfo?.admissionnumber
  const studentParentPhoneNum = studentInfo?.phonenumber
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [clickedDropdown, setClickedDropdown] = useState('All Homework');
  const [noHomework, setNoHomework] = useState(false);
  const [newHomework, setNewHomework] = useState(true);
  const [fetchedPayments, setFetchedPayments] = useState([]);
  const [fundingError, setFundingError] = useState("");
  const [numberSet, setnumberSet] = useState('');
  const [fetchedWalletInfo, setFetchedWalletInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showBalance, setShowBalance] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [fetchEmpty, setFetchEmpty] = useState(true);
  const [viewFront, setViewFront] = useState('Bills');
  const [showModal, setShowModal] = React.useState(false);
  const [copyingSuccess, setCopyingSuccess] = useState(false);
  const [fundWalletMode, setFundWalletMode] = useState(false);
  // const [fundingLoading, setfundingLoading] = useState(false);
  const dataContext = useContext(DataContext);
  const [imputedAmount, setImputedAmount] = useState('');

  const homeworkDropdown = [
    'All Homework',
    'Due Soon',
    'Over Due',
    'Submitted',
    'Marked',
  ];
  const showDropdown = classNames({
    hidden: !displayDropdown,
    'bg-white absolute mt-10 z-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500': true,
  });

  const host = dataContext.host;

  useEffect(() => {
    getPayments();
    return () => { };
  }, []);
  useEffect(() => {
    getWalletDetails();
    return () => { };
  }, []);

  const getPayments = async () => {
    try {


      const urlParams = studentAdmissionNum
      setnumberSet(urlParams)
      const encodedAdmission = urlParams.replace(/\//g, '%2F');
      setLoading(true);
      const { data } = await axios.get(
        `https://edves.cloud/api/v1/payments/student_bills/${encodedAdmission}`
      );

      setFetchedWalletInfo(data);

      setFetchEmpty(data.data.status);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setFetchError(true);
    }
  };

  const getWalletDetails = async () => {
    try {


      const urlParams = studentParentPhoneNum
      // const encodedAdmission = urlParams.replace(/\//g, '%2F');
      setLoading(true);
      const { data } = await axios.get(
        `https://edves.cloud/api/v1/payments/parents_wallet/${urlParams}`
      );

      console.log("meeeeeee");
      console.log({ data });
      setFetchedPayments(data);

      setFetchEmpty(data.data.status);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setFetchError(true);
    }
  };

  const Heading = () => (
    <>
      <span className='text-2xl leading-7 text-white mt-1'>
        {' '}
        Bills and Fees
      </span>
    </>
  );
  const pageSvg = () => (
    <>
      <HomeworkSvg />
    </>
  );

  const ProcessFundWallet = async (credentials) => {
    // setfundingLoading(true)
    if (credentials?.amount === "") {
      setFundingError("amount is empty")
      return
    }
    const acct_num = fetchedPayments?.wallets?.group1?.students[0]?.account_number
    try {
      setLoading(true);
      const { data } = await axios.get(
        `https://edves.cloud/api/v1/payments/wallet_funding/?wallet_id=${acct_num}&amount=${credentials?.amount}`
      );
      // console.log(data, "payment Id");
      if (data?.payment_link && data.payment_link.trim() !== "") {
        window.open(data.payment_link, "_blank");
        setLoading(false);
      } else {
        setLoading(false);
        // setErrorMessage(data?.detail);
      }
    } catch (error) {
      setLoading(false);
      // setFetchError(true);
    }
  };

  const CodeSchema = Yup.object().shape({
    // amount: Yup.number().required("Amount Code is required"),
    amount: Yup.number()
      .required('ERROR: The number is required!')
      .test(
        'Is positive?',
        'ERROR: The number must be greater than 0!',
        (value) => value > 0
      )
  });

  const copyToClipboard = (text) => {
    // alert(text)
    // Create a temporary textarea element
    const textarea = document.createElement('textarea');
    // Set the value of the textarea to the text to be copied
    textarea.value = text;
    // Make the textarea invisible
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    // Append the textarea to the DOM
    document.body.appendChild(textarea);
    // Select the text inside the textarea
    textarea.select();
    // Copy the selected text to the clipboard
    document.execCommand('copy');
    // Remove the textarea from the DOM
    document.body.removeChild(textarea);
    showCopyMsg()

  };
  const tabItems = [
    {
      label: "Locker",
      path: "locker"
    },
    {
      label: "CBT",
      path: "cbt"
    },
    {
      // label:  localStorage.getItem('schoolDomain') === 'demo.edves.net' ? "Chatroom" : '',
      label: "Chatroom",
      path: "chatroom"
    }
  ];

  const TabItemContainer = ({ children }) => (
    <div>{children}</div>
  );
  const showCopyMsg = () => {
    setTimeout(() => {
      setCopyingSuccess(true);
    }, 1000);
    setTimeout(() => {
      setCopyingSuccess(false);
    }, 2000);
  }
  const handleInputChange = (e) => {
    const value = e.target.value;
    // Regular expression to allow only numbers
    const regex = /^[0-9]+$/;
    // const regex = /^[1-9]\d*\.?\d*$|^0?\.\d+$|^0$/;

    if (value === "" || regex.test(value)) {
      setImputedAmount(value);
    }
  };


  const TabItem = ({ item }) => {
    const dataContext = useContext(DataContext);
    console.log(dataContext.hideSidebar)
    const location = useLocation();
    const isCurrentRoute = location.pathname === `/${item.path}`;
    const classes = classNames({
      'px-4 mx-4 -mb-2 py-1 leading-4 text-sm text-gray-100 flex flex-column justify-center items-end font-semibold': true,
      'text-gray-200 hover:text-blue-100 transform transition ease-in-out duration-100': !isCurrentRoute,
      'text-blue-100': isCurrentRoute
    });
    const showBar = classNames({
      'w-24 mx-4 -mb-2 h-1 inline-block': !isCurrentRoute,
      'w-24 mx-4 -mb-2 h-1 bg-blue-100 inline-block rounded-t': isCurrentRoute
    })

    const BottomBar = () => (
      <span className={showBar} />
    );

    return (
      <div>
        <Link to={item.path} className={classes}>
          {item.label}
        </Link>
        {item.path === 'chatroom' && <BottomBar />}
        {/* {item.path === 'chatroom' && window.location.host === 'demo.edves.net' ? '' : <BottomBar />}           */}
      </div>
    )
  }
  const Title = () => <div className='flex flex-col justify-base'>Wallet Information<div className='text-sm'>View your wallet details, wallet balance, and top up your wallet</div> </div>;
  const Body = () => (
    <div className="mt-4">
      <div className="w-full">
        <div className="w-full h-full p-5 flex justify-between items-center" style={{ background: "linear-gradient(90deg, rgba(174,92,67,1) 23%, rgba(27,17,12,0.9990589985994398) 54%, rgba(174,92,67,1) 87%)", borderRadius: "16px 16px 0px  0px", border: "solid 1px #e8b09d", minHeight: "118px" }}>
          <div className='w-auto'>
            <div className="font-light text-base text-white">
              Your Wallet Balance
            </div>
            <div className="font-light text-white font-semibold" style={{ fontSize: 25 }}>
              &#8358;{fetchedPayments?.total_wallet_balance}
            </div>
          </div>
          {!fundWalletMode ? <div className="cursor-pointer bg-blue-100 py-2 px-3 font-semibold text-white text-[14px] tracking-[0] leading-[21px] whitespace-nowrap" style={{ borderRadius: 4 }} onClick={() => setFundWalletMode(true)}>
            Fund wallet
          </div> : <div className="cursor-pointer bg-blue-100 py-2 px-3 font-semibold text-white text-[14px] tracking-[0] leading-[21px] whitespace-nowrap" style={{ borderRadius: 4 }} onClick={() => setFundWalletMode(false)}>
            View Account
          </div>}





        </div>
      </div>
      <div className="w-full">
        {!fundWalletMode ? <div className="w-full h-[245px]">
          {fetchedPayments?.wallets?.group1?.students.map((item, index) => (
            index === 0 && (
              <div className="relative w-full p-3" style={{ background: "#fdfdfd", border: "solid 1px #e4eff9", borderRadius: "0px_0px_4px_4px" }}>
                {copyingSuccess && <FormSuccess text={"Copied!!!"} />}
                <div className="w-full p-3" style={{ borderBottom: 'solid 1px #e4eff9' }}>
                  <div className="w-full flex justify-between align-center">
                    <div className="font-semibold" style={{ color: "#000c15" }}>
                      Account Name
                    </div>
                    <div className="flex justify-center align-center gap-3">
                      <div style={{ color: "#000c15" }}>
                        {item?.parent_name}
                      </div>
                      <ContentCopy onClick={() => copyToClipboard(item?.parent_name)} className="!w-[12px] !h-[12px] cursor-pointer" />
                    </div>
                  </div>
                </div>
                <div className="w-full p-3" style={{ borderBottom: 'solid 1px #e4eff9' }}>
                  <div className="w-full flex justify-between align-center">
                    <div className="font-semibold" style={{ color: "#000c15" }}>
                      Account Number
                    </div>
                    <div className="flex justify-center align-center gap-3">
                      <div style={{ color: "#000c15" }}>
                        {item?.bank_account_number}
                      </div>
                      <ContentCopy onClick={() => copyToClipboard(item?.bank_account_number)} className="!w-[12px] !h-[12px] cursor-pointer" />
                    </div>
                  </div>
                </div>
                <div className="w-full p-3" style={{ borderBottom: 'solid 1px #e4eff9' }}>
                  <div className="w-full flex justify-between align-center">
                    <div className="font-semibold" style={{ color: "#000c15" }}>
                      Bank Name
                    </div>
                    <div className="flex justify-center align-center gap-3">
                      <div style={{ color: "#000c15" }}>
                      Globus Bank
                      </div>
                      <ContentCopy onClick={() => copyToClipboard("Globus Bank")} className="!w-[12px] !h-[12px]" />
                    </div>
                  </div>
                </div>
                <div className="w-full flex gap-2 pt-2 pb-2 hidden">
                  <ErrorOutline className="!w-[16px] !h-[16px] mt-1" color="#FFA800" />
                  <p className="w-full text-[14px] ">
                    Cash transfers sent to this bank account number will automatically top up your EDVES Wallet
                  </p>

                </div>
              </div>
            )
          ))}
        </div> : <div className="w-full h-[245px]">
          <div className="relative w-full p-3" style={{ background: "#fdfdfd", border: "solid 1px #e4eff9", borderRadius: "0px_0px_4px_4px" }}>
            <Formik
              initialValues={{
                amount: "",
              }}
              onSubmit={(Values) => ProcessFundWallet(Values)}
              validationSchema={CodeSchema}
            >
              {() => (
                <Form className="">

                  {fundingError && (
                    <FormError text={fundingError} />
                  )}
                  <div className="mb-2 w-full sm:w-5/6">
                    <div className="mb-1">
                      <Label text="Amount" />
                    </div>
                    <FormInput
                      ariaLabel="Amount"
                      name="amount"
                      // onChange={handleInputChange}
                      // pattern="[0-9]*"
                      type="text"
                    // value={imputedAmount}
                    />
                  </div>

                  <div className="mt-6 w-36">
                    <Button
                      type="submit"
                      text="Proceed"
                      loading={loading}
                    />
                  </div>
                </Form>
              )}
            </Formik>

          </div>
        </div>}

      </div>
    </div>
  );


  const Tabs = () => {
    return (
      <>
        {tabItems.map((items, index) => (
          <>
            <TabItemContainer className='flex flex-column' key={index}>
              <TabItem item={items} />

            </TabItemContainer>
          </>
        ))}
      </>
    )
  }

  const ref = useRef();

  useOnClick(ref, () => setDisplayDropdown(false));

  const transitionStyles = useSpring({
    to: [{ opacity: 1, transform: 'translateX(0)' }],
    from: { opacity: 0, transform: 'translateX(80px)' },
    config: { duration: 700 },
  });
  const closeModal = () => {
    setShowModal(false);
  };

  // console.log({ fetchedPayments });

  return (
    <>
      <animated.div
        style={transitionStyles}
        className='px-4 sm:flex sm:-mt-2 sm:px-0'
      >
        <div className='w-full md:w-2/3 sm:pl-2'>
          <PageNav Heading={Heading} PageSvg={pageSvg} />
          <div className="relative w-full mt-5 mb-5">
            <div className="flex w-full justify-between">
              <div className="">
                <div className="w-[639px] [font-family:'Source_Sans_Pro-SemiBold',Helvetica] font-semibold text-[#000c15] text-[24px] tracking-[0] leading-[36px]">
                  Current Bills
                </div>
                <p className="w-[639px] [font-family:'Source_Sans_Pro-Regular',Helvetica] font-normal text-[#000c15] text-sm tracking-[0] leading-[24px]">
                  Select multiple checkboxes to make multiple payments at once
                </p>

              </div>
              <div className="w-[176px] h-[40px] border border-blue-100 rounded-md">
                <div className="cursor-pointer  relative w-[146px] h-[21px] flex gap-2  pr-3 pl-3 pt-1 pb-1" onClick={() => setShowModal(!showModal)}>
                  <div className="[font-family:'Source_Sans_Pro-SemiBold',Helvetica] font-semibold text-black text-[14px] tracking-[0] leading-[21px] whitespace-nowrap">
                    View Wallet
                  </div>

                </div>
                <div className="cursor-pointer  relative flex items-center justify-center gap-2  pl-3 pr-3" onClick={() => setShowBalance(!showBalance)}>
                  <Visibility className="w-4 h-4 cursor-pointer" color="black"  />
                  {showBalance ? <div className="font-normal text-blue text-1  whitespace-nowrap">
                  N{fetchedPayments?.total_wallet_balance}
                  </div> : <div className="font-normal text-blue text-1  whitespace-nowrap">
                    ******
                  </div>}
                  

                </div>
              </div>
            </div>
          </div>
          <div className='w-full flex border-b gap-3' style={{ borderColor: "#E1E2E3" }}>
            <div className={`flex items-center cursor-pointer ${viewFront === "Bills" && "border-b-2 border-blue-100 "}`} onClick={() => setViewFront("Bills")}>
              <div className={`pt-3 pb-3 ${viewFront !== "Bills" && "text-grey-500"}`}>
                Current Bills
              </div>
              <div className={`w-auto h-5  pl-2 rounded pr-2 ml-1 flex items-center justify-center ${viewFront === "Bills" ? "bg-blue-800" : "bg-grey-400 text-white"}`}></div>
            </div>

            <div className={`flex items-center cursor-pointer ${viewFront === "History" && "border-b-2 border-blue-100 "}`} onClick={() => setViewFront("History")}>
              <div className={`pt-3 pb-3 ${viewFront !== "History" && "text-grey-500"}`}>
                Bill History
              </div>
              <div className={`w-auto h-5  pl-2 rounded pr-2 ml-1 flex items-center justify-center ${viewFront === "History" ? "bg-blue-800" : "bg-grey-400 text-white"}`}></div>
            </div>

          </div>
          {viewFront === "Bills" ? <div className='pt-6 w-full'>
            <Payments />
          </div> : <BillHistory />}

        </div>
      </animated.div>
      {showModal && (
        <BareboneModal closeModal={closeModal} Title={Title} Body={Body} />
      )}
    </>
  );
};

export default Billings;
